export default __webpack_public_path__ + "static/media/filstats01.99adf8ea.png";